export default class Breadcrumbs extends HTMLElement
{
    constructor()
    {
        super();

        const template = document.querySelector("#breadcrumbs").content;
        this.attachShadow({ mode: "open" }).appendChild(template.cloneNode(true));
    }

    static get observedAttributes()
    {
        return ['stylesheet'];
    }

    connectedCallback()
    {
        this.arrowTemplate = document.querySelector('#breadcrumbs-arrow').content;
        this.stylesheetElement = this.shadowRoot.querySelector('[name="stylesheet"]');
        this.stylesheetElement.href = this.stylesheet;
        this.createSlots();
    }

    createSlots()
    {
        var container = this.shadowRoot.querySelector('.breadcrumbs-container');
        var links = this.querySelectorAll('[slot]');
        let className = this.getAttribute('data-class');
        if (className) {
            container.classList.add(className);
        }
        links.forEach((link, index, links) => {
            let slot = document.createElement('slot');
            slot.setAttribute('name', index);
            slot.classList.add('breadcrumbs-link');
            container.appendChild(slot);

            if (index < links.length - 1) {
                container.appendChild(this.arrowTemplate.cloneNode(true));
            }
        });
    }

    get stylesheet()
    {
        return this.getAttribute('stylesheet');
    }
}
